(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2492],{

/***/ 41127:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[slug]",
      function () {
        return __webpack_require__(35568);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 66377:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ PostAuthor; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _common_Typography_Typography__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20026);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89755);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_legacy_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_icons_hi__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53854);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89583);





const SocialLink = (param)=>/*#__PURE__*/ {
    let { href , icon  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        href: href,
        className: "transition-colors text-copy-on-dark",
        target: "_blank",
        rel: "noreferrer",
        children: icon
    });
};
function PostAuthor(param) {
    let { profilePhoto , firstName , lastName , title , hidePhoto , personalWebsiteLink , twitterLink , githubLink , hideTitle , linkedInLink  } = param;
    var _url;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex gap-3",
        children: [
            !hidePhoto && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "overflow-hidden rounded-full w-12 h-12 border-solid border-[3px] border-divider-on-dark relative",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                    src: (_url = profilePhoto.url) !== null && _url !== void 0 ? _url : "",
                    layout: "fill",
                    alt: "author picture",
                    objectFit: "cover"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-col items-start",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_common_Typography_Typography__WEBPACK_IMPORTED_MODULE_1__/* .Typography */ .Z, {
                                type: "copy3",
                                emphasis: true,
                                children: [
                                    firstName,
                                    " ",
                                    lastName
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-wrap gap-2 pointer-events-auto",
                                children: [
                                    personalWebsiteLink && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SocialLink, {
                                        href: personalWebsiteLink,
                                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_hi__WEBPACK_IMPORTED_MODULE_3__/* .HiGlobeAlt */ .lKz, {})
                                    }),
                                    twitterLink && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SocialLink, {
                                        href: twitterLink,
                                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_4__/* .FaTwitter */ .fWC, {})
                                    }),
                                    githubLink && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SocialLink, {
                                        href: githubLink,
                                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_4__/* .FaGithub */ .hJX, {})
                                    }),
                                    linkedInLink && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SocialLink, {
                                        href: linkedInLink,
                                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_4__/* .FaLinkedin */ .ltd, {})
                                    })
                                ]
                            })
                        ]
                    }),
                    !hideTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_Typography_Typography__WEBPACK_IMPORTED_MODULE_1__/* .Typography */ .Z, {
                        type: "copy4",
                        className: "text-copy-on-dark",
                        children: title
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 75517:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cx": function() { return /* binding */ getTagUrl; },
/* harmony export */   "Md": function() { return /* binding */ PostTag; },
/* harmony export */   "N_": function() { return /* binding */ TagTab; }
/* harmony export */ });
/* unused harmony export SidebarTag */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_icons_hi__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53854);
/* harmony import */ var react_icons_ai__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8193);
/* harmony import */ var react_icons_io__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51649);
/* harmony import */ var _common_Typography_Typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20026);







const getTagUrl = (slug)=>slug === "all" || !slug ? "/blog" : "/blog/tag/".concat(slug);
function TagIcon(param) {
    let { slug , className  } = param;
    const iconMap = {
        all: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_hi__WEBPACK_IMPORTED_MODULE_4__/* .HiCollection */ .CAn, {
            className: className
        }),
        "highlight-engineering": /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_hi__WEBPACK_IMPORTED_MODULE_4__/* .HiCog */ .oq2, {
            className: className
        }),
        "developer-tooling": /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_hi__WEBPACK_IMPORTED_MODULE_4__/* .HiTerminal */ .Zbf, {
            className: className
        }),
        "session-replay": /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_hi__WEBPACK_IMPORTED_MODULE_4__/* .HiPlay */ .bKy, {
            className: className
        }),
        "debugging-and-troubleshooting": /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ai__WEBPACK_IMPORTED_MODULE_5__/* .AiFillBug */ .zax, {
            className: className
        }),
        "performance-monitoring": /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io__WEBPACK_IMPORTED_MODULE_6__/* .IoIosStopwatch */ .M66, {
            className: className
        }),
        "frontend-monitoring": /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_hi__WEBPACK_IMPORTED_MODULE_4__/* .HiChartPie */ .twD, {
            className: className
        })
    };
    var _slug;
    return (_slug = iconMap[slug]) !== null && _slug !== void 0 ? _slug : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_hi__WEBPACK_IMPORTED_MODULE_4__/* .HiTag */ .IFg, {
        className: className
    });
}
function PostTag(param) {
    let { name , slug  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: getTagUrl(slug),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "rounded-full bg-white/[12%] w-fit px-3 py-0.5 select-none cursor-pointer hover:bg-copy-on-light transition-colors active:bg-black/25 active:transition-none text-copy-on-dark",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_Typography_Typography__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .Z, {
                type: "copy4",
                children: name
            })
        })
    });
}
function SidebarTag(param) {
    let { name , slug , current  } = param;
    return /*#__PURE__*/ _jsx(Link, {
        href: getTagUrl(slug),
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex gap-[3px] items-center text-copy-on-dark h-[30px] select-none cursor-pointer transition-all active:transition-none group hover:bg-divider-on-dark/30 active:bg-dark-background pl-[3px]",
            children: [
                /*#__PURE__*/ _jsx(TagIcon, {
                    slug: slug,
                    className: classNames("transition-all  group-hover:text-copy-on-dark", current ? "text-white" : "text-copy-on-light")
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    type: "copy3",
                    className: classNames("transition-all group-hover:opacity-100 group-hover:text-copy-on-dark", current ? "text-white opacity-100" : "opacity-70"),
                    emphasis: current,
                    children: name
                })
            ]
        })
    });
}
function TagTab(param) {
    let { name , slug , current  } = param;
    const tabBaseStyle = classnames__WEBPACK_IMPORTED_MODULE_1___default()("flex gap-2 flex-0 items-center h-[30px] select-none box-content cursor-pointer hover:opacity-100 transition-opacity active:opacity-50 active:transition-none leading-none px-1 pb-2 group border-b-2 border-0 border-solid");
    const tabColorStyle = classnames__WEBPACK_IMPORTED_MODULE_1___default()(current ? "text-highlight-yellow border-highlight-yellow" : "text-copy-on-dark border-transparent");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: getTagUrl(slug),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(tabBaseStyle, tabColorStyle),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(current ? "text-highlight-yellow" : "opacity-70 group-hover:opacity-100 transition-opacity", "mt-1"),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TagIcon, {
                        slug: slug
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_Typography_Typography__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .Z, {
                    type: "copy2",
                    className: "w-max",
                    emphasis: current,
                    children: name
                })
            ]
        })
    });
}


/***/ }),

/***/ 96736:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "d": function() { return /* binding */ HighlightCodeBlock; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/Docs/Docs.module.scss
var Docs_module = __webpack_require__(75698);
var Docs_module_default = /*#__PURE__*/__webpack_require__.n(Docs_module);
// EXTERNAL MODULE: ./node_modules/react-code-blocks/dist/react-code-blocks.esm.js + 13 modules
var react_code_blocks_esm = __webpack_require__(41443);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/common/CodeBlock/highlight-code-theme.ts
var highlight_code_theme = __webpack_require__(10198);
// EXTERNAL MODULE: ./node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(89755);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
;// CONCATENATED MODULE: ./public/images/document-duplicate.svg
/* harmony default export */ var document_duplicate = ({"src":"/_next/static/media/document-duplicate.070abf52.svg","height":20,"width":20});
;// CONCATENATED MODULE: ./public/images/checkmark_circle.svg
/* harmony default export */ var checkmark_circle = ({"src":"/_next/static/media/checkmark_circle.ba3ad5e6.svg","height":16,"width":16});
// EXTERNAL MODULE: ./components/common/Typography/Typography.tsx
var Typography = __webpack_require__(20026);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/listbox/listbox.js + 4 modules
var listbox = __webpack_require__(33507);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 4 modules
var transition = __webpack_require__(31407);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/20/solid/esm/ChevronUpDownIcon.js
var ChevronUpDownIcon = __webpack_require__(46032);
;// CONCATENATED MODULE: ./components/Docs/HighlightCodeBlock/HighlightCodeBlock.tsx












const HighlightCodeBlock = (props)=>{
    const [copied, setCopied] = (0,react.useState)(false);
    const [selected, setSelected] = (0,react.useState)(0);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Docs_module_default()).codeBlock,
        style: props.style,
        children: [
            props.topbar && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Docs_module_default()).codeBlockTopper,
                children: props.product.types && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-28 ml-6",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(listbox/* Listbox */.R, {
                        value: selected,
                        onChange: setSelected,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(listbox/* Listbox.Button */.R.Button, {
                                    className: "relative w-full cursor-pointer rounded-lg bg-dark-background py-2 my-[10px] pl-3 pr-4 text-left shadow-md focus:outline-none focus-visible:border-indigo-500 focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-orange-300 sm:text-sm",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                            type: "copy4",
                                            emphasis: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "block truncate",
                                                children: props.product.types[selected]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronUpDownIcon/* default */.Z, {
                                                className: "h-5 w-5 text-gray-400",
                                                "aria-hidden": "true"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                                    as: react.Fragment,
                                    leave: "transition ease-in duration-100",
                                    leaveFrom: "opacity-100",
                                    leaveTo: "opacity-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(listbox/* Listbox.Options */.R.Options, {
                                        className: "absolute mt-1 max-h-60 w-full overflow-auto rounded-md border-2 border-divider-on-dark bg-color-primary-500 py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm",
                                        children: props.product.types.map((type, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(listbox/* Listbox.Option */.R.Option, {
                                                className: (param)=>{
                                                    let { active  } = param;
                                                    return "relative cursor-pointer select-none mx-1 py-1 pl-2 pr-4 rounded-md ".concat(active ? "bg-divider-on-dark text-white" : "text-copy-on-dark");
                                                },
                                                value: index,
                                                children: (param)=>/*#__PURE__*/ {
                                                    let { selected  } = param;
                                                    return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "block truncate ".concat(selected ? "font-medium" : "font-normal"),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                                type: "copy4",
                                                                emphasis: true,
                                                                children: type
                                                            })
                                                        })
                                                    });
                                                }
                                            }, index))
                                    })
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_code_blocks_esm/* CodeBlock */.dn, {
                language: props.language,
                text: props.text || props.product.snippets[selected] || "",
                showLineNumbers: props.showLineNumbers,
                theme: highlight_code_theme/* default */.Z
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((Docs_module_default()).codeCopyIcon, "".concat(props.topbar ? "mt-1" : "")),
                onClick: ()=>{
                    var _text;
                    navigator.clipboard.writeText((_text = props.text) !== null && _text !== void 0 ? _text : "");
                    setCopied(true);
                    setTimeout(()=>setCopied(false), 1000);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: document_duplicate,
                    alt: "Copy"
                })
            }),
            copied && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((Docs_module_default()).codeCopyIcon, (Docs_module_default()).active, "".concat(props.topbar ? "mt-1" : "")),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: checkmark_circle,
                    alt: "Text Copied"
                })
            })
        ]
    });
};


/***/ }),

/***/ 10198:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const highlightCodeTheme = {
    lineNumberColor: "#6272a4",
    lineNumberBgColor: "#282a36",
    backgroundColor: "#282a36",
    textColor: "#FFFFFF",
    substringColor: "#36E79B",
    keywordColor: "#FF5377",
    attributeColor: "#FF9457",
    selectorTagColor: "#8be9fd",
    docTagColor: "#36E79B",
    nameColor: "#66d9ef",
    builtInColor: "#FF9457",
    literalColor: "#FF5377",
    bulletColor: "#8BE9FD",
    codeColor: "#FF9457",
    additionColor: "#36E79B",
    regexpColor: "#36E79B",
    symbolColor: "#36E79B",
    variableColor: "#FFFFFF",
    templateVariableColor: "#FF5377",
    linkColor: "#00bcd4",
    selectorAttributeColor: "#FF5377",
    selectorPseudoColor: "#FF5377",
    typeColor: "#8BE9FD",
    stringColor: "#36E79B",
    selectorIdColor: "#FF9457",
    selectorClassColor: "#FF9457",
    quoteColor: "#E9F284",
    templateTagColor: "#FF5377",
    deletionColor: "#FF5377",
    titleColor: "#ff5580",
    sectionColor: "#FFFFFF",
    commentColor: "#6272A4",
    metaKeywordColor: "#FF9457",
    metaColor: "#FF9457",
    functionColor: "#FF9457",
    numberColor: "#bd93f9"
};
/* harmony default export */ __webpack_exports__["Z"] = (highlightCodeTheme);


/***/ }),

/***/ 62223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ Section; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _Section_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50246);
/* harmony import */ var _Section_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Section_module_scss__WEBPACK_IMPORTED_MODULE_3__);




const Section = (param)=>{
    let { reverseMobile , className , children , noYBottomPadding , noYTopPadding , grid , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ...props,
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, (_Section_module_scss__WEBPACK_IMPORTED_MODULE_3___default().section), {
            [(_Section_module_scss__WEBPACK_IMPORTED_MODULE_3___default().sectionReverseMobile)]: reverseMobile,
            [(_Section_module_scss__WEBPACK_IMPORTED_MODULE_3___default().noYTopPadding)]: noYTopPadding,
            [(_Section_module_scss__WEBPACK_IMPORTED_MODULE_3___default().noYBottomPadding)]: noYBottomPadding,
            [(_Section_module_scss__WEBPACK_IMPORTED_MODULE_3___default().gridSection)]: grid
        }),
        children: children
    });
};


/***/ }),

/***/ 35568:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(89755);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
// EXTERNAL MODULE: ./components/Home/Home.module.scss
var Home_module = __webpack_require__(19350);
var Home_module_default = /*#__PURE__*/__webpack_require__.n(Home_module);
// EXTERNAL MODULE: ./components/Blog/Blog.module.scss
var Blog_module = __webpack_require__(50848);
var Blog_module_default = /*#__PURE__*/__webpack_require__.n(Blog_module);
// EXTERNAL MODULE: ./components/common/Section/Section.tsx
var Section = __webpack_require__(62223);
// EXTERNAL MODULE: ./components/common/Footer/Footer.tsx + 1 modules
var Footer = __webpack_require__(5945);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/common/CallToAction/FooterCallToAction.tsx + 1 modules
var FooterCallToAction = __webpack_require__(24035);
// EXTERNAL MODULE: ./node_modules/react-youtube/dist/YouTube.esm.js
var YouTube_esm = __webpack_require__(13913);
// EXTERNAL MODULE: ./node_modules/@graphcms/rich-text-react-renderer/dist/rich-text-react-renderer.esm.js + 1 modules
var rich_text_react_renderer_esm = __webpack_require__(60392);
// EXTERNAL MODULE: ./components/common/Typography/Typography.tsx
var Typography = __webpack_require__(20026);
// EXTERNAL MODULE: ./components/common/HighlightLogo/HighlightLogo.tsx + 2 modules
var HighlightLogo = __webpack_require__(44688);
// EXTERNAL MODULE: ./components/common/Navbar/Navbar.module.scss
var Navbar_module = __webpack_require__(36109);
var Navbar_module_default = /*#__PURE__*/__webpack_require__.n(Navbar_module);
// EXTERNAL MODULE: ./components/common/Buttons/PrimaryButton.tsx
var PrimaryButton = __webpack_require__(29204);
// EXTERNAL MODULE: ./components/common/Banner/Banner.tsx
var Banner = __webpack_require__(67852);
// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var index_esm = __webpack_require__(8193);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./public/images/ReturnIcon.tsx
var ReturnIcon = __webpack_require__(69976);
// EXTERNAL MODULE: ./components/Blog/Tag.tsx
var Tag = __webpack_require__(75517);
;// CONCATENATED MODULE: ./components/Blog/BlogNavbar/BlogNavbar.tsx












const SHOW_NAVBAR_OFFSET = 300;
const BlogNavbar = (param)=>{
    let { title , endPosition , attachUnder , singleTag  } = param;
    const [scrolled, setScrolled] = (0,react.useState)(false);
    const [isOpen, setIsOpen] = (0,react.useState)(false);
    const [prevY, setPrevY] = (0,react.useState)(0);
    const changeBackground = ()=>{
        const currentScrollPos = window.pageYOffset;
        if (window.scrollY > SHOW_NAVBAR_OFFSET) {
            setScrolled(true);
        } else if (window.scrollY <= SHOW_NAVBAR_OFFSET) {
            setScrolled(false);
        }
        setPrevY(currentScrollPos * 1.3);
    };
    (0,react.useEffect)(()=>{
        changeBackground();
        window.addEventListener("scroll", changeBackground);
    });
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Banner/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Navbar_module_default()).bannerContainerBlog,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Want 2 weeks of free Highlight? "
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "http://app.highlight.io/",
                                className: (Navbar_module_default()).callToAction,
                                children: "Register Here →"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Navbar_module_default()).navContainer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            className: classnames_default()((Navbar_module_default()).menuList, (Navbar_module_default()).header),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/pricing",
                                        className: (Navbar_module_default()).menuItem,
                                        children: "Pricing"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/#customers",
                                        className: (Navbar_module_default()).menuItem,
                                        children: "Customers"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/blog",
                                        className: (Navbar_module_default()).menuItem,
                                        children: "Blog"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "https://careers.highlight.run",
                                        className: (Navbar_module_default()).menuItem,
                                        children: "Careers"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/docs",
                                        className: (Navbar_module_default()).menuItem,
                                        children: "Docs"
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                className: classnames_default()((Navbar_module_default()).headerPadding, {
                    [(Navbar_module_default()).hideNavbar]: !scrolled,
                    [(Navbar_module_default()).mobileHeader]: isOpen
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()((Navbar_module_default()).header, (Navbar_module_default()).headerInner, {
                            [(Navbar_module_default()).openHeader]: isOpen,
                            [(Navbar_module_default()).headerBorder]: prevY != 0
                        }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/",
                                className: (Navbar_module_default()).urlStyle,
                                children: isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HighlightLogo/* HighlightLogoWhite */.s, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(HighlightLogo/* HighlightLogo */.R, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()((Navbar_module_default()).navContainer, (Navbar_module_default()).headerLeftBlog),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Navbar_module_default()).navPostTitle,
                                    children: title
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Navbar_module_default()).navMenu,
                                onClick: ()=>setIsOpen(!isOpen),
                                children: isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlineClose */.oHP, {
                                    className: (Navbar_module_default()).copyOnDark
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlineMenu */.qTj, {})
                            }),
                            isOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Navbar_module_default()).mobileMenu,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: classnames_default()((Navbar_module_default()).menuList, (Navbar_module_default()).header),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                    type: "copy3",
                                                    emphasis: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/pricing",
                                                        className: (Navbar_module_default()).menuItemLarge,
                                                        children: "Pricing"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                    type: "copy3",
                                                    emphasis: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/#customers",
                                                        className: (Navbar_module_default()).menuItemLarge,
                                                        children: "Customers"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                    type: "copy3",
                                                    emphasis: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/blog",
                                                        className: (Navbar_module_default()).menuItemLarge,
                                                        children: "Blog"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                    type: "copy3",
                                                    emphasis: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "https://careers.highlight.run",
                                                        className: (Navbar_module_default()).menuItemLarge,
                                                        children: "Careers"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                    type: "copy3",
                                                    emphasis: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/docs",
                                                        className: (Navbar_module_default()).menuItemLarge,
                                                        children: "Docs"
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (Navbar_module_default()).menuButtons,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryButton/* PrimaryButton */.K, {
                                                href: "https://app.highlight.io/?sign_up=1",
                                                children: "Get Started"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                type: "copy3",
                                                emphasis: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://app.highlight.io/",
                                                    className: (Navbar_module_default()).menuItem,
                                                    children: "Sign In"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()((Navbar_module_default()).navContainer, (Navbar_module_default()).header, (Navbar_module_default()).headerRight),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryButton/* PrimaryButton */.K, {
                                    href: "https://app.highlight.io/?sign_up=1",
                                    className: (Navbar_module_default()).signUpButton,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                        type: "copy2",
                                        emphasis: true,
                                        children: "Sign up"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Navbar_module_default()).loadingBar,
                        style: {
                            width: "".concat((1 - Math.max(0, endPosition - prevY) / endPosition) * 100, "%")
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-full",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                            href: (0,Tag/* getTagUrl */.Cx)((ref = singleTag === null || singleTag === void 0 ? void 0 : singleTag.slug) !== null && ref !== void 0 ? ref : "all"),
                            className: "flex-row hidden gap-2 mt-6 ml-8 desktop:flex place-items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ReturnIcon/* default */.Z, {}),
                                " Back"
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var BlogNavbar_BlogNavbar = (BlogNavbar);

// EXTERNAL MODULE: ./components/Products/Products.module.scss
var Products_module = __webpack_require__(49879);
var Products_module_default = /*#__PURE__*/__webpack_require__.n(Products_module);
;// CONCATENATED MODULE: ./components/common/CallToAction/BlogCallToAction.tsx







const BlogCallToAction = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((Home_module_default()).callToActionBackground, (Home_module_default()).simpleCallToActionBackground),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()((Home_module_default()).anchorTitle, (Home_module_default()).ctaContainer),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Products_module_default()).subtleBadge,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                        type: "copy4",
                        emphasis: true,
                        children: "Try Highlight Today"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                    className: (Home_module_default()).ctaTitle,
                    children: [
                        "Get the ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (Home_module_default()).highlightedText,
                            children: "visibility"
                        }),
                        " you need"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()((Home_module_default()).buttonContainer, (Home_module_default()).tryButtonContainer),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryButton/* PrimaryButton */.K, {
                        href: "https://app.highlight.io/?sign_up=1",
                        style: {
                            color: "black"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                            type: "copy2",
                            emphasis: true,
                            children: "Get started for free"
                        })
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/Blog/SuggestedBlogPost/SuggestedBlogPost.tsx








const SuggestedBlogPost = (param)=>{
    let { slug , richcontent , image , title , publishedAt , tags_relations , readingTime  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/blog/".concat(slug),
        style: {
            textDecoration: "none"
        },
        legacyBehavior: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()((Blog_module_default()).blogPost, (Blog_module_default()).suggestedBlogPost),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Blog_module_default()).cardSection,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Blog_module_default()).cardImage,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: (image === null || image === void 0 ? void 0 : image.url) || "",
                            alt: "",
                            layout: "fill",
                            objectFit: "cover"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Blog_module_default()).cardSection,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Blog_module_default()).postDateDiv,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                type: "copy2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "".concat(new Date(publishedAt).toLocaleDateString("en-US", {
                                        day: "numeric",
                                        year: "numeric",
                                        month: "short"
                                    }), " • ").concat(readingTime || Math.floor(richcontent.markdown.split(" ").length / 200), " min. read")
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Blog_module_default()).suggestedPostTitle,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                type: "copy1",
                                emphasis: true,
                                children: title
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Blog_module_default()).tagDiv,
                            children: tags_relations.map((tag)=>/*#__PURE__*/ (0,react.createElement)(Tag/* PostTag */.Md, {
                                    ...tag,
                                    key: tag.slug + slug
                                }))
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./components/common/Head/Meta.tsx
var Meta = __webpack_require__(50745);
// EXTERNAL MODULE: ./components/Docs/HighlightCodeBlock/HighlightCodeBlock.tsx + 2 modules
var HighlightCodeBlock = __webpack_require__(96736);
// EXTERNAL MODULE: ./components/Blog/Author.tsx
var Author = __webpack_require__(66377);
;// CONCATENATED MODULE: ./pages/blog/[slug].tsx




















const getBlogTypographyRenderer = (type)=>{
    function ParagraphBody(param) {
        let { content  } = param;
        if (content.text) {
            if (content.code) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (Blog_module_default()).codeInline,
                    children: content.text
                });
            } else if (content.italic) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    children: content.text
                });
            } else if (content.bold) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                    children: content.text
                });
            } else if (content.text.indexOf("://") !== -1) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: content.text.split("/").map((p)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                p,
                                "/",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("wbr", {})
                            ]
                        }))
                });
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: content.text
            });
        } else if (content.href) {
            var ref;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: content.href,
                ...content.openInNewTab ? {
                    target: "_blank",
                    rel: "noopener noreferrer"
                } : {},
                children: content === null || content === void 0 ? void 0 : (ref = content.children) === null || ref === void 0 ? void 0 : ref.map((c, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ParagraphBody, {
                        content: c
                    }, "child-".concat(idx)))
            });
        }
        return null;
    }
    function ParagraphHeader(param) {
        let { children  } = param;
        var ref;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,react.createElement)(type, {
                className: (Blog_module_default()).blogText
            }, children === null || children === void 0 ? void 0 : (ref = children.props) === null || ref === void 0 ? void 0 : ref.content.map((c, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ParagraphBody, {
                    content: c
                }, idx)))
        });
    }
    return ParagraphHeader;
};
var // update here to support other tags
SectionType;
(function(SectionType) {
    SectionType["CallToAction"] = "{{CALL_TO_ACTION}}";
})(SectionType || (SectionType = {}));
const PostSection = (param)=>{
    let { p  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(rich_text_react_renderer_esm/* RichText */.H, {
                content: {
                    children: p.nodes
                },
                renderers: {
                    code_block: (param)=>{
                        let { children  } = param;
                        var ref;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(HighlightCodeBlock/* HighlightCodeBlock */.d, {
                            language: "js",
                            text: children === null || children === void 0 ? void 0 : (ref = children.props) === null || ref === void 0 ? void 0 : ref.content[0].text,
                            showLineNumbers: false
                        });
                    },
                    h1: getBlogTypographyRenderer("h1"),
                    h2: getBlogTypographyRenderer("h2"),
                    h3: getBlogTypographyRenderer("h3"),
                    h4: getBlogTypographyRenderer("h4"),
                    h5: getBlogTypographyRenderer("h5"),
                    h6: getBlogTypographyRenderer("h6"),
                    p: getBlogTypographyRenderer("p"),
                    img: (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Blog_module_default()).blogImageContainer,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                className: (Blog_module_default()).blogImage,
                                src: props.src || "",
                                alt: props.altText,
                                width: props.width,
                                height: props.height
                            })
                        })
                }
            }),
            p.footer === "BlogCallToAction" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogCallToAction, {}) : null
        ]
    });
};
const PostPage = (param)=>{
    let { post , postSections , suggestedPosts  } = param;
    var ref;
    const blogBody = (0,react.useRef)(null);
    const [endPosition, setEndPosition] = (0,react.useState)(0);
    (0,react.useEffect)(()=>{
        var ref;
        setEndPosition(((ref = blogBody.current) === null || ref === void 0 ? void 0 : ref.offsetHeight) || 0);
    // recalculate end position when blog sections are processed
    // because at that point the page height is finalized
    }, [
        postSections
    ]);
    const isStartupStack = post.tags_relations.filter((t)=>t.name.toLocaleLowerCase().includes("stack")).length > 0;
    const singleTag = post.tags_relations.length === 1 ? post.tags_relations[0] : undefined;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* Meta */.h, {
                title: post.metaTitle || post.title,
                description: post.metaDescription || post.description,
                absoluteImageUrl: "https://".concat("highlight-landing-k4fv4li30-highlight-run.vercel.app", "/api/og/blog/").concat(post.slug),
                canonical: "/blog/".concat(post.slug)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogNavbar_BlogNavbar, {
                title: post.title,
                endPosition: endPosition,
                singleTag: singleTag
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                ref: blogBody,
                className: classnames_default()((Blog_module_default()).mainBlogPadding, "relative"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* Section */.$, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()((Home_module_default()).anchorTitle, (Blog_module_default()).blogSection),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                    type: "copy2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (Blog_module_default()).dateDiv,
                                        children: "".concat(new Date(post.publishedAt).toLocaleDateString("en-US", {
                                            day: "numeric",
                                            year: "numeric",
                                            month: "short"
                                        }), " • ").concat(post.readingTime || Math.floor(post.richcontent.markdown.split(" ").length / 200), " min read")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: (Blog_module_default()).blogText,
                                    children: post.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()((Blog_module_default()).tagDiv, (Blog_module_default()).postTagDiv),
                                    children: post.tags_relations.map((tag)=>/*#__PURE__*/ (0,react.createElement)(Tag/* PostTag */.Md, {
                                            ...tag,
                                            key: tag.slug
                                        }))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Blog_module_default()).authorDiv,
                                    children: post.author && /*#__PURE__*/ (0,jsx_runtime.jsx)(Author/* PostAuthor */.M, {
                                        ...post.author
                                    })
                                })
                            ]
                        })
                    }),
                    ((ref = post.image) === null || ref === void 0 ? void 0 : ref.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* Section */.$, {
                        className: (Blog_module_default()).headerSection,
                        children: isStartupStack ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()((Blog_module_default()).youtubeEmbed, (Home_module_default()).anchorTitle, (Blog_module_default()).blogSection),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(YouTube_esm/* default */.Z, {
                                videoId: post.youtubeVideoId || "dQw4w9WgXcQ",
                                style: {
                                    display: "flex",
                                    justifyContent: "center"
                                }
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()((Blog_module_default()).mainImage, (Home_module_default()).anchorTitle, (Blog_module_default()).blogSection),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: post.image.url || "",
                                alt: "",
                                layout: "fill",
                                objectFit: "cover",
                                priority: true
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* Section */.$, {
                        className: (Blog_module_default()).headerSection,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()((Home_module_default()).anchorTitle, (Blog_module_default()).postBody, (Blog_module_default()).postBodyTop, (Blog_module_default()).blogSection),
                            children: postSections === null || postSections === void 0 ? void 0 : postSections.map((p, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(PostSection, {
                                    idx: idx,
                                    p: p
                                }, idx))
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* Section */.$, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Blog_module_default()).postBodyDivider
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* Section */.$, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()((Home_module_default()).anchorTitle, (Blog_module_default()).postBody),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: (Blog_module_default()).otherArticlesHeader,
                                    children: "Other articles you may like"
                                }),
                                suggestedPosts.map((p, i)=>/*#__PURE__*/ (0,react.createElement)(SuggestedBlogPost, {
                                        ...p,
                                        key: i
                                    }))
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterCallToAction/* FooterCallToAction */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var _slug_ = (PostPage);


/***/ }),

/***/ 69976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

const ReturnIcon = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M19 7V11H5.83L9.41 7.41L8 6L2 12L8 18L9.41 16.59L5.83 13H21V7H19Z",
            fill: "currentColor"
        })
    });
/* harmony default export */ __webpack_exports__["Z"] = (ReturnIcon);


/***/ }),

/***/ 50848:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"blogContainer":"Blog_blogContainer__RcYz1","blogSection":"Blog_blogSection__ob5ix","tagContainer":"Blog_tagContainer__Ca1se","copyOnDark":"Blog_copyOnDark__icLCO","tagHeader":"Blog_tagHeader__koSPS","suggestedBlogPost":"Blog_suggestedBlogPost__5cjSY","cardImage":"Blog_cardImage__XNHLl","cardSection":"Blog_cardSection__b1BFz","suggestedPostTitle":"Blog_suggestedPostTitle__BL5A7","blogPost":"Blog_blogPost___Voip","blogPostSmall":"Blog_blogPostSmall__glYdY","postDateDiv":"Blog_postDateDiv__CpP7p","tagDiv":"Blog_tagDiv__4TCOb","bodyText":"Blog_bodyText___VbtI","avatar":"Blog_avatar__lmA0z","authorDiv":"Blog_authorDiv__OfWDl","authorDescription":"Blog_authorDescription__LHLkW","authorDetails":"Blog_authorDetails__FRlgF","mainBlogPadding":"Blog_mainBlogPadding__fAxBt","mainImage":"Blog_mainImage__io3SO","youtubeEmbed":"Blog_youtubeEmbed__YfQbH","tagSortTitle":"Blog_tagSortTitle__Wn_4G","selectedTag":"Blog_selectedTag__UFOjS","dateDiv":"Blog_dateDiv__eBLrY","postTagDiv":"Blog_postTagDiv___Yc8e","suggestedPostDiv":"Blog_suggestedPostDiv__9_6Vh","suggestedPost":"Blog_suggestedPost__xTA8q","postBodyTop":"Blog_postBodyTop__UvyVH","headerSection":"Blog_headerSection__DLrZP","postBody":"Blog_postBody__v_Dyg","codeBlock":"Blog_codeBlock__KCkc2","codeInline":"Blog_codeInline__1fz_b","postBodyDivider":"Blog_postBodyDivider__4_LDF","otherArticlesHeader":"Blog_otherArticlesHeader__Qz5m8","blogImageContainer":"Blog_blogImageContainer__107eO","blogImage":"Blog_blogImage__Kb_Mj","blogText":"Blog_blogText__MlX8v"};

/***/ }),

/***/ 75698:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mainWrapper":"Docs_mainWrapper__FXUeq","docsCard":"Docs_docsCard__otr1Y","docsCardGroup":"Docs_docsCardGroup__01dpF","docsCardPara":"Docs_docsCardPara__p_t5V","leftSection":"Docs_leftSection__obmR_","listItem":"Docs_listItem__yoc5q","active":"Docs_active__1H8j4","emptyContent":"Docs_emptyContent__HZyG5","searchResultCard":"Docs_searchResultCard__HoCml","content":"Docs_content__eXCi0","resultTitle":"Docs_resultTitle__u_Ok4","highlightedText":"Docs_highlightedText__qEoz1","tocIcon":"Docs_tocIcon__jhnhr","tocRow":"Docs_tocRow__uCwZO","tocChild":"Docs_tocChild__DEzRd","tocItem":"Docs_tocItem__zayx3","tocItemChevronClosed":"Docs_tocItemChevronClosed__vvJYn","tocItemOpen":"Docs_tocItemOpen__3TrfE","tocItemCurrent":"Docs_tocItemCurrent__I8muf","tocChildren":"Docs_tocChildren__PoknC","tocChildrenLineWrapper":"Docs_tocChildrenLineWrapper__GbkOD","tocChildrenLine":"Docs_tocChildrenLine__l3kNX","tocChildrenContent":"Docs_tocChildrenContent__yTpCr","pageTitle":"Docs_pageTitle__rtkmX","sdkPageTitle":"Docs_sdkPageTitle__koGyT","quickStartSubtext":"Docs_quickStartSubtext__F6fJJ","contentRender":"Docs_contentRender__xZOXl","sdkRightColumn":"Docs_sdkRightColumn__yipIy","sdkLeftColumn":"Docs_sdkLeftColumn__KZyoS","inlineCodeBlock":"Docs_inlineCodeBlock__i42rv","headingCopyIcon":"Docs_headingCopyIcon__L6gY8","docSelect":"Docs_docSelect__ry3Bu","docSelectText":"Docs_docSelectText__eKCeK","chevronDown":"Docs_chevronDown__d47Bs","docSelectList":"Docs_docSelectList__sZvi9","contentInnerBar":"Docs_contentInnerBar__oVUjo","leftInner":"Docs_leftInner__RF3OK","centerInner":"Docs_centerInner__bL99U","searchContainer":"Docs_searchContainer__0qCYJ","searchDiv":"Docs_searchDiv__u4Smh","spinner":"Docs_spinner__RE0vP","codeBlock":"Docs_codeBlock__GmOTo","codeBlockTopper":"Docs_codeBlockTopper__nWwNU","codeCopyIcon":"Docs_codeCopyIcon__8Tsch","contentSection":"Docs_contentSection__3OQpo","centerSection":"Docs_centerSection__jxxYw","sdkCenterSection":"Docs_sdkCenterSection__WkN9l","quickStartCenterSection":"Docs_quickStartCenterSection__yktxM","rightSection":"Docs_rightSection__SZw9H","headingSection":"Docs_headingSection__x5be1","docLink":"Docs_docLink__taM7v","rightBarWrap":"Docs_rightBarWrap__jakYW","socialItem":"Docs_socialItem__fuzrp","sdkSocialItem":"Docs_sdkSocialItem__5dt4_","resourcesSideBar":"Docs_resourcesSideBar__lgF62","resourcesMobile":"Docs_resourcesMobile__uiihJ","pageContentTable":"Docs_pageContentTable__fTiVM","pageNavigateRow":"Docs_pageNavigateRow__QcMzN","pageNavigate":"Docs_pageNavigate__CdpBF","pageContentTitle":"Docs_pageContentTitle__EhHKD","pageContentIcon":"Docs_pageContentIcon__iQl8C","pageContentList":"Docs_pageContentList__Lzsbr","pageContentBullet":"Docs_pageContentBullet__DjElc","breadcrumb":"Docs_breadcrumb__bU57t","tocMenu":"Docs_tocMenu__l8_Vh","tocMenuLarge":"Docs_tocMenuLarge__eUA0l","customComponent":"Docs_customComponent___gky_","callout":"Docs_callout__TRexG","calloutIcon":"Docs_calloutIcon__6q_MY","icon":"Docs_icon__GZ_cR","calloutContent":"Docs_calloutContent__MYxQS","sdkDocSection":"Docs_sdkDocSection__vCPp1","methodParameter":"Docs_methodParameter__PZHhd","innerParameterContainer":"Docs_innerParameterContainer__U8ZlW","innerParameterHeading":"Docs_innerParameterHeading__NS93a","sdkRender":"Docs_sdkRender__SrVGr","tocMenuLabel":"Docs_tocMenuLabel__DutJo","tocContents":"Docs_tocContents__HV81g"};

/***/ }),

/***/ 50246:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"Section_section__2Pzmc","gridSection":"Section_gridSection__vgdkS","noYTopPadding":"Section_noYTopPadding__CWdmK","noYBottomPadding":"Section_noYBottomPadding__efv2e","sectionReverseMobile":"Section_sectionReverseMobile__q0tjM"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5445,4617,6556,9866,3826,1443,392,2228,8795,8558,9774,2888,179], function() { return __webpack_exec__(41127); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);